import { Loading, Modal } from "@quark/design";
import { useEffect, useState } from "react";
import Footer from "../../component/footer";
import Navigator from "../../component/navigator";
import styles from "./index.module.scss";
import { InviteCourse, Wallet } from "../../types/invite";
import { formatCurrency } from "../../utils";
import { getInviteCourses, getMyWallet } from "../../api";
import { CASH_BACK } from "../../constants";
import CourseShareIcon from "../../icons/cource-share";
import { QRCodeCanvas } from "qrcode.react";

const Promotion = () => {
  const [loading, setLoading] = useState(false);
  const [courses, setCourses] = useState<InviteCourse[]>([]);
  const [wallet, setWallet] = useState<Wallet>({
    user_id: 0,
    withdraw_fee: 0,
    balance_fee: 0,
    unsettle_fee: 0,
  });
  const [mobileModalVisible, setMobileModalVisible] = useState(false);

  const cnyFormat = (fenNum: number) => {
    return formatCurrency(fenNum / 100);
  };

  const init = () => {
    setLoading(true);
    Promise.all([getInviteCourses(), getMyWallet()])
      .then(([courseData, walletData]) => {
        setCourses(courseData);
        setWallet(walletData);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const toMobilePage = () => {
    setMobileModalVisible(true);
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <div className={styles.container}>
        <Navigator activeKey="promotion" />
        <div className={styles.content}>
          {loading && <Loading style={{ height: "80vh" }} />}

          <div className={styles.wallet}>
            <div className={styles.item}>
              <div className={styles.title}>现金余额</div>
              <div className={styles.amount}>
                {cnyFormat(wallet.balance_fee)}
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.title}>待结算</div>
              <div className={styles.amount}>
                {cnyFormat(wallet.unsettle_fee)}
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.title}>累计返现</div>
              <div className={styles.amount}>
                {cnyFormat(wallet.withdraw_fee)}
              </div>
            </div>
            <div className={styles.actions}>
              <div className={styles.action} onClick={toMobilePage}>
                提现
              </div>
              <div className={styles.action} onClick={toMobilePage}>
                明细
              </div>
            </div>
          </div>

          <div className={styles.wrapper}>
            <div className={styles.cources}>
              <div className={styles.header}>
                课程分享 &nbsp; &nbsp;
                <a
                  href="https://mp.weixin.qq.com/s/LR2ME4LCGlcDCZ0E6yU48g"
                  target="__blank"
                >
                  如何邀请返现?
                </a>
              </div>
              {courses.map((course) => {
                return (
                  <div
                    className={styles.course}
                    key={course.id}
                    onClick={toMobilePage}
                  >
                    <div className={styles.cover}>
                      <img src={course.mini_cover_img} alt="" />
                    </div>
                    <div className={styles.courseContent}>
                      <div className={styles.title}>{course.title}</div>
                      <div className={styles.subTitle}>
                        {course.learning_points}
                      </div>
                      <div className={styles.benefit}>
                        分享成功返现{CASH_BACK}元
                      </div>
                      <div className={styles.share}>
                        <CourseShareIcon />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <Footer />

      <Modal
        onClose={() => setMobileModalVisible(false)}
        visible={mobileModalVisible}
        title="手机端操作提现"
        contentClassName={styles.qrcodeWrapper}
      >
        <QRCodeCanvas
          size={240}
          value="https://edu.py2fun.com/mobile/#/promotion"
        />
        <div className={styles.tips}>
          <div>微信扫一扫</div>
          <div>移步至手机端操作</div>
        </div>
      </Modal>
    </>
  );
};

export default Promotion;
